import { CSSProperties } from 'react';
import styled from 'styled-components';

export const iconStyle: CSSProperties = { marginRight: '6px' };

export const NavWrapper = styled.div`
  display: flex;
  height: auto;
  align-items: center;
  flex-wrap: nowrap;

  @media (max-width: 1280px) {
    display: none;
  }
`;
